import pureWhite from "@/assets/materials/pure-white.webp";
import absoluteBlack from "@/assets/materials/absolute-black.webp";
import milkyPink from "@/assets/materials/milky-pink.jpg";
import apricot from "@/assets/materials/apricot.webp";
import babyBlue from "@/assets/materials/baby-blue.webp";
import apricotTransparent from "@/assets/materials/apricot-t.webp";
import babyBlueTransparent from "@/assets/materials/baby-blue-t.webp";

/* Transparent PNG/WEBP cut-outs (no background) for feature visuals. */
export const MATERIAL_IMAGES_T = {
  Apricot: apricotTransparent,
  "Baby Blue": babyBlueTransparent,
};

/*
 * Slots for the transparent (no-background) versions of every PLA color.
 * Apricot & Baby Blue are ready; the remaining three are placeholders (null)
 * awaiting the corresponding transparent PNG/WebP assets from Strato.
 */
export const MATERIAL_TRANSPARENT = {
  "Pure White": null,
  "Absolute Black": null,
  "Milky Pink": null,
  Apricot: apricotTransparent,
  "Baby Blue": babyBlueTransparent,
};

/*
 * Real product photos of the SAME printed object in each PLA color.
 * Provided by Strato Lab 3D — used as the definitive material color visuals.
 */
export const MATERIAL_IMAGES = {
  "Pure White": pureWhite,
  "Absolute Black": absoluteBlack,
  "Milky Pink": milkyPink,
  Apricot: apricot,
  "Baby Blue": babyBlue,
};

export const MATERIAL_COLORS = [
  { name: "Pure White", hex: "#F5F5F5", note: "Opaco", img: pureWhite },
  { name: "Absolute Black", hex: "#0B0D10", note: "Opaco", img: absoluteBlack },
  { name: "Milky Pink", hex: "#F2D6DE", note: "Pastello", img: milkyPink },
  { name: "Apricot", hex: "#F3C7A6", note: "Pastello", img: apricot },
  { name: "Baby Blue", hex: "#BFD7EA", note: "Pastello", img: babyBlue },
];
